"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonderQueryBuilder = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const factories_1 = require("../../../../config/factories");
const impermax_factories_1 = require("../../../../config/contracts/impermax-factories");
class PonderQueryBuilder {
    /*-----------------------------*
     *   1. API Health
     *-----------------------------*/
    // Add queries here for metadata, health, etc.
    blockQuery() {
        return (0, graphql_tag_1.default) `{
        _meta {
          status
        }
      }`;
    }
    getBlockNumber(response, network) {
        return response.data._meta.status[network].block.number || 0;
    }
    /*-----------------------------*
     *   2. Lending pools
     *-----------------------------*/
    lendingPoolsQuery(factory, addressesFilter, network) {
        const tokenStr = `{
      id
      symbol
      name
      decimals
      derivedUSD
    }`;
        const distributorStr = `{ 
      id 
    }`;
        const farmingPoolStr = `{
      epochAmount
      epochBegin
      segmentLength
      vestingBegin
      sharePercentage
      distributor ${distributorStr}
    }`;
        const borrowableStr = `{
      id
      underlying ${tokenStr}
      totalBalance
      totalBorrows
      borrowRate
      reserveFactor
      kinkBorrowRate
      kinkUtilizationRate
      adjustSpeed
      borrowIndex
      accrualTimestamp 
      exchangeRate 
      borrowTracker
      farmingPool ${farmingPoolStr}
    }`;
        const collateralStr = `{
      id
      totalBalance
      safetyMargin
      liquidationIncentive
      ${factories_1.LIQUIDATION_FEE_FACTORIES.includes(factory) ? "liquidationFee" : ""}
      exchangeRate 
    }`;
        const pairStr = `{
      factory
      reserve0
      reserve1
      totalSupply
      reserveUSD
      token0Price
      token1Price
      derivedUSD
      uniswapV2PairAddress
      uniswapV2Factory
      isStakedLPToken
      exchangeRate
      stakingRewards 
      masterChef
      pid
      stakedTotalSupply
      rewards {
        items { 
          id
          rewardRate
          rewardsToken ${tokenStr}
          periodFinish
        }
      }
    }`;
        const id_in_string = addressesFilter.length > 0 ? `id_in: ["${addressesFilter.join('","').toLowerCase()}"]}` : "";
        return (0, graphql_tag_1.default) `{
      lendingPools(
        limit: 1000
        orderBy: "totalBorrowsUSD"
        where: { factoryId: "${impermax_factories_1.IMPERMAX_FACTORY[network][factory]}", ${id_in_string}}
      ) {
        items {
          id
          borrowable0 ${borrowableStr}
          borrowable1 ${borrowableStr}
          collateral ${collateralStr}
          pair ${pairStr}
        }
      }
      _meta {
        status
      }
    }`;
    }
    userQuery(account, network, factory) {
        return (0, graphql_tag_1.default) `{
      user(id: "${account.toLowerCase()}") {
        collateralPositions(limit:1000, where: { factoryId: "${impermax_factories_1.IMPERMAX_FACTORY[network][factory]}"}) {
          items { 
            balance
            collateral {
              lendingPool {
                id
              }
            }
          }
        }
        supplyPositions(limit:1000, where: { factoryId: "${impermax_factories_1.IMPERMAX_FACTORY[network][factory]}"}) {
          items { 
            balance
            borrowable {
              underlying {
                id
              }
              lendingPool {
                id
              }
            }
          }
        }
        borrowPositions(limit:1000, where: { factoryId: "${impermax_factories_1.IMPERMAX_FACTORY[network][factory]}"}) {
          items { 
            borrowBalance
            borrowIndex
            borrowable {
              underlying {
                id
              }
              lendingPool {
                id
              }
            }
          }
        }
      }
      _meta {
        status
      }
    }`;
    }
    tvlQuery() {
        return (0, graphql_tag_1.default) `
      {
        impermaxFactorys(limit: 1) {
          items {
            id
            totalBalanceUSD
            totalSupplyUSD
            totalBorrowsUSD
          }
        }
        _meta {
          status
        }
      }
    `;
    }
    /*-----------------------------*
     *   Lending vaults
     *-----------------------------*/
    lendingVaultsUserQuery(account) {
        return (0, graphql_tag_1.default) `{
      user(id: "${account.toLowerCase()}") {
        positions(first:1000) {
          tokenBalance
          lastExchangeRate
          cumulativeEarnings
          lendingVault {
              id
          }
        }
      }
    }`;
    }
    lendingVaultsQuery(addressesFilter) {
        const id_in_string = addressesFilter.length > 0 ? `where: {id_in: ["${addressesFilter.join('","').toLowerCase()}"]}` : "";
        return (0, graphql_tag_1.default) `{
      lendingVaults(first: 1000 ${id_in_string}) {
          id
          underlying {
              id
              symbol
              name
              decimals
          }
          totalBalance
          totalSupply
          supplyRate
          reserveFactor
          exchangeRate
          availableLiquidity
          lastUpdate
      }
      _meta {
          block {
              number
          }
          hasIndexingErrors
      }
    }`;
    }
    /*-----------------------------*
     *   Config Manager
     *-----------------------------*/
    // TODO: Add config manager ponder
    proposalsMetaQuery(rangeBegin, rangeLength, descending) {
        return (0, graphql_tag_1.default) `{
      proposals(
        orderBy: "idInt", 
        orderDirection: ${descending ? "desc" : "asc"},
        limit: ${rangeLength},
      ) {
        items { 
          id
          state
        }
      }
    }`;
    }
    proposalQuery(id) {
        return (0, graphql_tag_1.default) `{
      proposal(id: "${id}") {
        id
        state
        pairConfig {
          items { 
            factory
            pair
            safetyMarginSqrt
            liquidationIncentive
            liquidationFee
            reserveFactor0
            reserveFactor1
            kinkUtilizationRate0
            kinkUtilizationRate1
            adjustSpeed0
            adjustSpeed1
            borrowTracker0
            borrowTracker1
            whiteListState
          }
        }
      }
    }`;
    }
    /*-----------------------------*
     *   IBEX
     *-----------------------------*/
    // TODO: Add IBEX ponder idk what this is
    ximxQuery() {
        return (0, graphql_tag_1.default) `{
        ximxes(first: 1) {
          totalSupply
          totalBalance
          exchangeRate
          dailyAPR
        }
      }
    `;
    }
}
exports.PonderQueryBuilder = PonderQueryBuilder;
